module.exports = __webpack_public_path__ + "img/12th_college.efa43369.webp";